import { createSelector } from '@reduxjs/toolkit';

import { getAcadlyRouteByURL } from '../../pages/helpers';
import { RootState } from '../../store/types';
import { AcadlyPage } from '../shared/types';

export const selectSortByPrefs = (state: RootState) => state.db.app.userPreferences.sortBy;

export const selectTipsPrefs = (state: RootState) => state.db.app.userPreferences.tips;

export const selectAccessibilityPrefs = (state: RootState) => state.db.app.userPreferences.accessibility;

export const selectNotificationPrefs = (state: RootState) => state.db.app.notificationPrefs;

export const selectUserSurvey = (state: RootState) => state.db.app.userSurvey;

/** Promotional Tips */

export const selectPromotionalTips = (state: RootState) => state.db.app.promotionalTips;

// FIXME: avoid repetition
const selectCurrentCourseId = (state: RootState) => state.db.courses.currentCourse;

const pagesOutsideCourse = [
  AcadlyPage.HOME,
  AcadlyPage.ARCHIVED_COURSES,
  AcadlyPage.SETTINGS,
  AcadlyPage.REFER,
];

export const selectPromotionalTipByUrl = createSelector(
  [selectPromotionalTips, selectCurrentCourseId, (state: RootState, url: string) => url],
  (promotionalTips, currentCourseId, url) => {
    const { name: routeName, match } = getAcadlyRouteByURL(url);
    if (!routeName || !match) return;

    const promotionalTip = Object.values(promotionalTips).find((promotionalTip) => {
      if (!promotionalTip) return false;
      if (routeName !== promotionalTip.viewId) return false;
      if (promotionalTip.isSeen) return false;

      // if page falls outside the course, then do not check courseId by returning early
      const isPageOutsideCourse = pagesOutsideCourse.includes(routeName);
      if (isPageOutsideCourse) return true;

      // currentCourseId should never be empty, just checking for typescript's convinience
      if (!currentCourseId) return false;
      return promotionalTip.courseIds.includes(currentCourseId);
    });

    return promotionalTip;
  }
);
